export enum MappingType {
  Skill = 0,
  Department = 1,
  Language = 2,
  Team = 3,
  Person = 4,
  Role = 5,
}

